<template>
  <receipt :refundable="true"/>
</template>

<script>
import Receipt from '@/views/inbound/receipt/Receipt.vue'

export default {
  name: 'SaleReturn',
  components: { Receipt }
}
</script>